import React from "react";
import "../Css/All.css";

const Contact = () => {
  return (
    <>
      <div className="contact">
        <div className="mainSection">
          <div className="contentBoxCenter">
            <h1>Let us work together</h1>

            <div className="contactUs">
              <h2>Proprietor: MEDURI SRI LAKSHMI SARADA HARIKA</h2>
              <h2>GSTIN: 36KLYPS7685Q1Z3</h2>
              <h3>Mailing Address</h3>
              <p>Ground floor MIG 963, Old Mig, BHEL- Telangana</p>
              <h3>Email Address</h3>
              <p>mailto: info@manognaa-solutions.com</p>
              <h3>Phone Number</h3>
              <p>+919490746930</p>
            </div>
          </div>
          <div className="imageContainerCenter">
            <div className="svgGraphic">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                zoomAndPan="magnify"
                viewBox="0 0 461.25 461.249984"
                preserveAspectRatio="xMidYMid meet"
                version="1.0"
              >
                <path
                  fill="#ccf3e5"
                  d="M 72.757812 374.664062 C 53.882812 356.765625 46.414062 330.488281 49.65625 302.679688 C 51.429688 287.5 51.246094 272.171875 49.671875 256.96875 C 46.289062 224.261719 59.59375 186.304688 88.269531 156.066406 C 123.046875 119.394531 170.351562 104.691406 207.230469 115.539062 C 224.253906 120.546875 242.472656 120.019531 259.015625 113.601562 C 295.882812 99.308594 335.28125 103.554688 361.460938 128.382812 C 400.609375 165.503906 395.378906 234.578125 349.777344 282.667969 C 324.496094 309.328125 292.113281 323.9375 261.605469 325.335938 C 249.601562 325.890625 238.476562 331.722656 231 341.132812 C 228.207031 344.648438 225.222656 348.089844 222.050781 351.4375 C 176.605469 399.355469 109.765625 409.757812 72.757812 374.664062 Z M 72.757812 374.664062 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 37.863119, 36.340944)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M 440.427315 748.01756 C 440.427315 748.01756 440.427315 549.005552 440.427315 549.005552 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 144.432019, 294.884406)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -68.808135 68.808091 C -68.808135 68.808091 68.806356 -68.8064 68.806356 -68.8064 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 37.863119, 36.340944)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M 81.952439 413.519924 C 81.952439 413.519924 281.102089 413.519924 281.102089 413.519924 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 146.55157, 146.905011)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -55.407353 -55.40259 C -55.407353 -55.40259 55.403649 55.408412 55.403649 55.408412 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 37.863119, 36.340944)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M 440.427315 140.493213 C 440.427315 140.493213 440.427315 268.151598 440.427315 268.151598 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 225.350989, 69.989284)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 74.043578 -0.00235493 C 74.043578 40.895677 40.890204 74.039876 0.00134766 74.039876 C -40.896684 74.039876 -74.040883 40.895677 -74.040883 -0.00235493 C -74.040883 -40.891211 -40.896684 -74.044585 0.00134766 -74.044585 C 40.890204 -74.044585 74.043578 -40.891211 74.043578 -0.00235493 Z M 74.043578 -0.00235493 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 225.350989, 219.222387)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 181.789751 0.000631864 C 181.789751 100.396721 100.397437 181.789035 0.00134766 181.789035 C -100.394742 181.789035 -181.787056 100.396721 -181.787056 0.000631864 C -181.787056 -100.395457 -100.394742 -181.787772 0.00134766 -181.787772 C 100.397437 -181.787772 181.789751 -100.395457 181.789751 0.000631864 Z M 181.789751 0.000631864 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 71.511462, 212.37502)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 74.042833 -0.0000472678 C 74.042833 40.888809 40.889459 74.042183 0.000602792 74.042183 C -40.897429 74.042183 -74.041628 40.888809 -74.041628 -0.0000472678 C -74.041628 -40.888903 -40.897429 -74.042278 0.000602792 -74.042278 C 40.889459 -74.042278 74.042833 -40.888903 74.042833 -0.0000472678 Z M 74.042833 -0.0000472678 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 113.857214, 111.596446)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 57.236629 0.00284339 C 57.236629 31.614627 31.616861 57.243571 -0.00409887 57.243571 C -31.615883 57.243571 -57.235651 31.614627 -57.235651 0.00284339 C -57.235651 -31.60894 -31.615883 -57.237885 -0.00409887 -57.237885 C 31.616861 -57.237885 57.236629 -31.60894 57.236629 0.00284339 Z M 57.236629 0.00284339 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 115.140696, 324.175751)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 57.240561 0.0000720801 C 57.240561 31.611856 31.611617 57.2408 -0.000167168 57.2408 C -31.611951 57.2408 -57.240895 31.611856 -57.240895 0.0000720801 C -57.240895 -31.611712 -31.611951 -57.240656 -0.000167168 -57.240656 C 31.611617 -57.240656 57.240561 -31.611712 57.240561 0.0000720801 Z M 57.240561 0.0000720801 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 225.350989, 354.770561)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 74.043578 -0.00241984 C 74.043578 40.895612 40.890204 74.039811 0.00134766 74.039811 C -40.896684 74.039811 -74.040883 40.895612 -74.040883 -0.00241984 C -74.040883 -40.891276 -40.896684 -74.04465 0.00134766 -74.04465 C 40.890204 -74.04465 74.043578 -40.891276 74.043578 -0.00241984 Z M 74.043578 -0.00241984 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 224.36337, 70.842809)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 51.560492 38.266691 C 51.560492 38.266691 -51.560909 38.266691 -51.560909 38.266691 C -51.560909 38.266691 -51.560909 -38.271448 -51.560909 -38.271448 C -51.560909 -38.271448 51.560492 -38.271448 51.560492 -38.271448 C 51.560492 -38.271448 51.560492 38.266691 51.560492 38.266691 Z M 51.560492 38.266691 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 226.337757, 69.214302)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 51.556426 38.265753 C 51.556426 38.265753 -51.555799 38.265753 -51.555799 38.265753 C -51.555799 38.265753 -51.555799 -38.26321 -51.555799 -38.26321 C -51.555799 -38.26321 51.556426 -38.26321 51.556426 -38.26321 C 51.556426 -38.26321 51.556426 38.265753 51.556426 38.265753 Z M 51.556426 38.265753 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 226.338167, 61.068592)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -51.556761 -19.137375 C -51.556761 -19.137375 0.00393939 19.136282 0.00393939 19.136282 C 0.00393939 19.136282 51.555464 -19.137375 51.555464 -19.137375 C 51.555464 -19.137375 -51.556761 -19.137375 -51.556761 -19.137375 Z M -51.556761 -19.137375 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 57.05948, 212.37461)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 12.881211 41.284345 C 12.881211 41.284345 -12.885375 41.284345 -12.885375 41.284345 C -12.885375 41.284345 -12.885375 -41.291691 -12.885375 -41.291691 C -12.885375 -41.291691 12.881211 -41.291691 12.881211 -41.291691 C 12.881211 -41.291691 12.881211 41.284345 12.881211 41.284345 Z M 12.881211 41.284345 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 71.511031, 216.170966)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 12.884909 32.366362 C 12.884909 32.366362 -12.881677 32.366362 -12.881677 32.366362 C -12.881677 32.366362 -12.881677 -32.371268 -12.881677 -32.371268 C -12.881677 -32.371268 12.884909 -32.371268 12.884909 -32.371268 C 12.884909 -32.371268 12.884909 32.366362 12.884909 32.366362 Z M 12.884909 32.366362 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 85.962584, 221.162697)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 12.879425 20.640335 C 12.879425 20.640335 -12.877985 20.640335 -12.877985 20.640335 C -12.877985 20.640335 -12.877985 -20.643095 -12.877985 -20.643095 C -12.877985 -20.643095 12.879425 -20.643095 12.879425 -20.643095 C 12.879425 -20.643095 12.879425 20.640335 12.879425 20.640335 Z M 12.879425 20.640335 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 113.857214, 111.050712)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 46.115154 10.965644 C 46.115154 10.965644 46.115154 -10.965317 46.115154 -10.965317 C 46.115154 -10.965317 34.470639 -10.965317 34.470639 -10.965317 C 33.846662 -12.92901 33.06669 -14.819294 32.130725 -16.617816 C 32.130725 -16.617816 40.361717 -24.857985 40.361717 -24.857985 C 40.361717 -24.857985 24.85405 -40.365653 24.85405 -40.365653 C 24.85405 -40.365653 16.623057 -32.125484 16.623057 -32.125484 C 14.824535 -33.06145 12.934251 -33.850597 10.961382 -34.474574 C 10.961382 -34.474574 10.961382 -46.119089 10.961382 -46.119089 C 10.961382 -46.119089 -10.960404 -46.119089 -10.960404 -46.119089 C -10.960404 -46.119089 -10.960404 -34.474574 -10.960404 -34.474574 C -12.933273 -33.850597 -14.823556 -33.06145 -16.622079 -32.125484 C -16.622079 -32.125484 -24.862248 -40.365653 -24.862248 -40.365653 C -24.862248 -40.365653 -40.360739 -24.857985 -40.360739 -24.857985 C -40.360739 -24.857985 -32.129746 -16.617816 -32.129746 -16.617816 C -33.065712 -14.819294 -33.85486 -12.92901 -34.478837 -10.965317 C -34.478837 -10.965317 -46.114176 -10.965317 -46.114176 -10.965317 C -46.114176 -10.965317 -46.114176 10.965644 -46.114176 10.965644 C -46.114176 10.965644 -34.478837 10.965644 -34.478837 10.965644 C -33.85486 12.929337 -33.065712 14.819621 -32.129746 16.618143 C -32.129746 16.618143 -40.360739 24.858312 -40.360739 24.858312 C -40.360739 24.858312 -24.862248 40.36598 -24.862248 40.36598 C -24.862248 40.36598 -16.622079 32.125811 -16.622079 32.125811 C -14.823556 33.061777 -12.933273 33.850924 -10.960404 34.474901 C -10.960404 34.474901 -10.960404 46.119416 -10.960404 46.119416 C -10.960404 46.119416 10.961382 46.119416 10.961382 46.119416 C 10.961382 46.119416 10.961382 34.474901 10.961382 34.474901 C 12.934251 33.850924 14.824535 33.061777 16.623057 32.125811 C 16.623057 32.125811 24.85405 40.36598 24.85405 40.36598 C 24.85405 40.36598 40.361717 24.858312 40.361717 24.858312 C 40.361717 24.858312 32.130725 16.618143 32.130725 16.618143 C 33.06669 14.819621 33.846662 12.929337 34.470639 10.965644 C 34.470639 10.965644 46.115154 10.965644 46.115154 10.965644 Z M 16.375301 0.86272 C 16.173427 4.744225 14.62266 8.258685 12.190984 10.965644 C 11.805586 11.396923 11.39266 11.800673 10.961382 12.195246 C 8.254422 14.626922 4.739963 16.168513 0.858458 16.370388 C 0.573998 16.38874 0.289537 16.38874 -0.00409887 16.38874 C -0.288559 16.38874 -0.573019 16.38874 -0.866656 16.370388 C -4.738984 16.168513 -8.253444 14.626922 -10.960404 12.195246 C -11.391682 11.800673 -11.804608 11.396923 -12.190006 10.965644 C -14.621681 8.258685 -16.172448 4.744225 -16.374323 0.86272 C -16.383499 0.57826 -16.392675 0.2938 -16.392675 0.000163511 C -16.392675 -0.293473 -16.383499 -0.577933 -16.374323 -0.862393 C -16.172448 -4.743898 -14.621681 -8.258358 -12.190006 -10.965317 C -11.804608 -11.396596 -11.391682 -11.800346 -10.960404 -12.194919 C -8.253444 -14.626595 -4.738984 -16.168186 -0.866656 -16.370061 C -0.573019 -16.388413 -0.288559 -16.388413 -0.00409887 -16.388413 C 0.289537 -16.388413 0.573998 -16.388413 0.858458 -16.370061 C 4.739963 -16.168186 8.254422 -14.626595 10.961382 -12.194919 C 11.39266 -11.800346 11.805586 -11.396596 12.190984 -10.965317 C 14.62266 -8.258358 16.173427 -4.743898 16.375301 -0.862393 C 16.384478 -0.577933 16.393654 -0.293473 16.393654 0.000163511 C 16.393654 0.2938 16.384478 0.57826 16.375301 0.86272 Z M 16.375301 0.86272 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 222.532028, 223.053213)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -25.94276 56.74868 C -25.94276 56.74868 -25.94276 49.655528 -25.94276 49.655528 C -25.94276 27.008828 -24.171766 12.721586 -20.629778 6.812155 C -17.078614 0.902724 -7.718957 -7.649433 7.467546 -18.853493 C 15.432431 -24.698691 20.96564 -30.149315 24.07635 -35.187013 C 27.18706 -40.224711 28.747003 -46.473659 28.747003 -53.943032 C 28.747003 -63.146695 25.819816 -70.395842 19.974618 -75.690471 C 14.120244 -80.975925 7.027092 -83.618652 -1.304838 -83.618652 C -23.336738 -83.618652 -35.715343 -68.065104 -38.449832 -36.958007 C -38.449832 -36.958007 -89.597606 -44.234682 -89.597606 -44.234682 C -85.74363 -72.359535 -75.43883 -93.638991 -58.701561 -108.073051 C -41.973467 -122.50711 -21.529039 -129.728728 2.613371 -129.728728 C 27.251293 -129.728728 47.906772 -122.635576 64.579808 -108.449272 C 81.262021 -94.262968 89.593951 -76.277744 89.593951 -54.502777 C 89.593951 -27.497412 75.719636 -4.914945 47.971005 13.253802 C 35.904388 21.218687 28.591008 27.440106 26.040043 31.91806 C 23.489077 36.396013 22.213595 44.672887 22.213595 56.74868 C 22.213595 56.74868 -25.94276 56.74868 -25.94276 56.74868 Z M 31.545724 129.726479 C 31.545724 129.726479 -27.062248 129.726479 -27.062248 129.726479 C -27.062248 129.726479 -27.062248 73.357484 -27.062248 73.357484 C -27.062248 73.357484 31.545724 73.357484 31.545724 73.357484 C 31.545724 73.357484 31.545724 129.726479 31.545724 129.726479 Z M 31.545724 129.726479 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 115.140682, 324.939451)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 36.731934 -0.0137595 C 36.731934 20.28385 20.279124 36.718308 -0.000133396 36.718308 C -20.279391 36.718308 -36.7322 20.28385 -36.7322 -0.0137595 C -36.7322 -19.999381 -20.747374 -36.250315 -0.881042 -36.718298 C -0.881042 -36.718298 -0.881042 -0.0137595 -0.881042 -0.0137595 C -0.881042 -0.0137595 36.731934 -0.0137595 36.731934 -0.0137595 Z M 36.731934 -0.0137595 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 125.584318, 314.239116)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -18.807271 -18.363406 C -18.807271 -18.363406 -18.807271 18.359485 -18.807271 18.359485 C -18.807271 18.359485 18.805705 18.359485 18.805705 18.359485 C 18.411131 -2.534573 3.279685 -17.867894 -18.807271 -18.363406 Z M -18.807271 -18.363406 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 225.350989, 405.47744)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 431.160387 13.789669 C 431.160387 13.789669 -431.157691 13.789669 -431.157691 13.789669 C -431.157691 13.789669 -431.157691 -13.784616 -431.157691 -13.784616 C -431.157691 -13.784616 431.160387 -13.784616 431.160387 -13.784616 C 431.160387 -13.784616 431.160387 13.789669 431.160387 13.789669 Z M 431.160387 13.789669 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 288.22809, 318.515248)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 54.796287 -39.263794 C 54.796287 -39.263794 41.729471 131.348077 41.729471 131.348077 C 36.902824 181.247898 -44.149973 173.402302 -39.323326 123.502482 C -54.803465 81.558371 -38.855343 -66.64538 -23.274267 -181.246126 C 20.037089 -158.296613 46.620351 -111.764434 54.796287 -39.263794 Z M 54.796287 -39.263794 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 346.371454, 306.730699)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -159.693118 -153.59986 C -129.806448 -171.970481 -100.552931 -187.964484 -72.556544 -199.25113 C -72.556544 -199.25113 58.864057 -209.959679 58.864057 -209.959679 C 93.733369 -196.70934 127.602482 -180.605224 159.691424 -159.399177 C 159.691424 -159.399177 92.485414 197.451524 92.485414 197.451524 C 4.293584 209.1878 -66.316772 209.958595 -110.921963 194.478456 C -110.921963 194.478456 -159.693118 -153.59986 -159.693118 -153.59986 Z M -159.693118 -153.59986 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="butt"
                  transform="matrix(0.425697, 0, 0, 0.425697, 345.467709, 212.590866)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="miter"
                  d="M 44.26812 -67.538752 C 44.26812 -67.538752 40.037922 -6.508281 40.037922 -6.508281 C 40.037922 -6.508281 -20.625505 67.543126 -20.625505 67.543126 C -20.625505 67.543126 -44.272404 23.37839 -44.272404 23.37839 C -44.272404 23.37839 -44.272404 -35.504866 -44.272404 -35.504866 C -44.272404 -35.504866 44.26812 -67.538752 44.26812 -67.538752 Z M 44.26812 -67.538752 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="10"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 345.46727, 198.957498)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -42.436147 3.522539 C -42.436147 3.522539 -42.436147 24.389069 -42.436147 24.389069 C 2.875606 25.260802 25.46725 5.935862 42.433923 -25.25382 C 13.721798 -4.919505 -12.512771 3.999698 -42.436147 3.522539 Z M -42.436147 3.522539 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 357.732882, 224.695124)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -49.437506 39.109128 C -49.437506 39.109128 -18.064302 21.711177 -18.064302 21.711177 C -18.064302 21.711177 -0.519532 46.688616 -0.519532 46.688616 C -0.519532 46.688616 49.435345 -20.223758 49.435345 -20.223758 C 49.435345 -20.223758 24.760719 -46.687731 24.760719 -46.687731 C 24.760719 -46.687731 12.042596 -46.687731 12.042596 -46.687731 C 12.042596 -46.687731 11.22592 -34.942278 11.22592 -34.942278 C 11.22592 -34.942278 -49.437506 39.109128 -49.437506 39.109128 Z M -49.437506 39.109128 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 326.084861, 229.632363)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 24.906557 27.511108 C 24.906557 27.511108 3.094885 13.682673 3.094885 13.682673 C 3.094885 13.682673 -21.038349 38.063663 -21.038349 38.063663 C -21.038349 38.063663 -24.901502 -18.140162 -24.901502 -18.140162 C -24.901502 -18.140162 1.259658 -38.06155 1.259658 -38.06155 C 1.259658 -38.06155 1.259658 -16.653628 1.259658 -16.653628 C 1.259658 -16.653628 24.906557 27.511108 24.906557 27.511108 Z M 24.906557 27.511108 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  fill="#231f1f"
                  d="M 299.152344 389.519531 C 299.152344 389.519531 299.152344 404.648438 299.152344 404.648438 C 325.738281 412.742188 355.214844 411.746094 386.628906 404.648438 C 386.628906 404.648438 385.742188 390.785156 385.742188 390.785156 C 352.125 395.914062 322.753906 396.082031 299.152344 389.519531 Z M 299.152344 389.519531 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 342.890112, 401.131045)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M -102.743975 -27.276495 C -102.743975 -27.276495 -102.743975 8.262674 -102.743975 8.262674 C -40.291202 27.275625 28.95191 24.926535 102.746385 8.262674 C 102.746385 8.262674 100.663402 -24.303428 100.663402 -24.303428 C 21.693587 -12.255163 -47.301769 -11.860589 -102.743975 -27.276495 Z M -102.743975 -27.276495 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 338.723372, 254.571365)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -26.594119 -44.901299 C -26.594119 -44.901299 -2.093839 48.475047 -2.093839 48.475047 C -2.093839 48.475047 26.590758 -48.470816 26.590758 -48.470816 C 26.590758 -48.470816 -4.782447 -31.072864 -4.782447 -31.072864 C -4.782447 -31.072864 -26.594119 -44.901299 -26.594119 -44.901299 Z M -26.594119 -44.901299 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 329.429988, 264.906436)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -15.08627 -50.817871 C -15.08627 -50.817871 15.084861 50.816997 15.084861 50.816997 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 348.556143, 262.244542)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 11.778739 -38.545297 C 11.778739 -38.545297 -11.776399 38.543411 -11.776399 38.543411 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 329.986399, 383.11683)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M -65.192014 -5.596603 C -24.587619 5.515696 19.210072 5.598282 65.191683 -1.889444 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 400.514535, 315.856778)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -48.621777 -40.479005 C -48.621777 -40.479005 -39.904449 130.417326 -39.904449 130.417326 C -36.344109 180.418084 35.982184 156.963884 44.947268 120.140056 C 48.617722 7.814991 41.561274 -88.240786 33.036645 -180.424235 C -10.834455 -158.585035 -38.601438 -112.741066 -48.621777 -40.479005 Z M -48.621777 -40.479005 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 325.746448, 357.867099)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -133.770522 -20.517629 C -66.454399 -49.046232 1.733458 -70.674381 54.679755 -78.024465 C 74.637848 -80.786481 94.972162 -78.731027 114.04017 -72.206795 C 114.04017 -72.206795 130.722383 -66.490064 130.722383 -66.490064 C 130.722383 -66.490064 136.879569 -25.390156 136.879569 -25.390156 C 136.879569 -25.390156 88.759919 -27.831008 88.759919 -27.831008 C 88.759919 -27.831008 -72.877693 70.839968 -72.877693 70.839968 C -112.041436 80.786898 -136.881232 63.150367 -133.770522 -20.517629 Z M -133.770522 -20.517629 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 356.321251, 353.949826)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 149.752313 -18.445458 C 100.118601 -39.486335 68.084714 -61.316359 25.690972 -71.657863 C -16.656889 -81.981014 -73.567276 -87.101297 -114.924115 -73.327919 C -114.924115 -73.327919 -154.684307 -61.967865 -154.684307 -61.967865 C -154.684307 -61.967865 -150.463285 -31.833438 -150.463285 -31.833438 C -150.463285 -31.833438 -99.168692 -25.309207 -99.168692 -25.309207 C -79.531764 -22.804122 -60.656455 -16.178953 -43.763191 -5.874154 C -43.763191 -5.874154 92.254653 77.160689 92.254653 77.160689 C 131.418396 87.098443 154.689073 70.865861 149.752313 -18.445458 Z M 149.752313 -18.445458 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  fill="#ffffff"
                  d="M 394.390625 325.734375 C 394.390625 325.734375 395.773438 351.554688 395.773438 351.554688 C 395.773438 351.554688 419.867188 357.507812 419.867188 357.507812 C 419.859375 348.253906 419.542969 338.648438 418.941406 328.730469 C 418.941406 328.730469 394.390625 325.734375 394.390625 325.734375 Z M 394.390625 325.734375 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  fill="#ffffff"
                  d="M 269.378906 341.699219 C 269.378906 341.699219 269.226562 350.554688 269.226562 350.554688 C 269.226562 350.554688 282.058594 346.441406 282.058594 346.441406 C 282.058594 346.441406 281.117188 336.875 281.117188 336.875 C 281.117188 336.875 269.378906 341.699219 269.378906 341.699219 Z M 269.378906 341.699219 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  fill="#231f1f"
                  d="M 298.773438 398.832031 C 298.773438 398.832031 298.566406 411.132812 298.566406 411.132812 C 298.566406 411.132812 327.496094 409.671875 326.921875 409.1875 C 326.34375 408.703125 326.730469 399.695312 326.730469 399.695312 C 326.730469 399.695312 298.773438 398.832031 298.773438 398.832031 Z M 298.773438 398.832031 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  fill="#231f1f"
                  d="M 364.527344 182.085938 C 364.527344 182.085938 326.109375 191.109375 326.109375 191.109375 C 326.109375 191.109375 325.785156 195.945312 325.785156 195.945312 C 325.785156 195.945312 326.316406 203.269531 326.316406 203.269531 C 326.316406 203.269531 353.925781 200.109375 360.136719 191.765625 C 366.351562 183.421875 363.84375 187.703125 363.84375 187.703125 C 363.84375 187.703125 364.527344 182.085938 364.527344 182.085938 Z M 364.527344 182.085938 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 302.410614, 137.535855)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -6.002267 -35.384816 C -10.204937 -7.287492 -4.680904 14.533356 2.348015 35.390711 C 2.348015 35.390711 10.202787 -34.494731 10.202787 -34.494731 C 10.202787 -34.494731 -6.002267 -35.384816 -6.002267 -35.384816 Z M -6.002267 -35.384816 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="butt"
                  transform="matrix(0.425697, 0, 0, 0.425697, 334.652454, 152.909031)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="miter"
                  d="M 73.473052 -15.743604 C 73.473052 -15.743604 72.803194 28.64136 72.803194 28.64136 C 72.803194 28.64136 69.01345 81.945526 69.01345 81.945526 C 33.767917 106.711913 -3.505542 119.228161 -44.476983 109.584044 C -53.249368 107.519413 -60.287463 100.986005 -63.049479 92.406319 C -75.217034 54.600645 -76.593454 2.204916 -67.481553 -64.358765 C -36.034939 -119.23205 33.54769 -115.882761 76.592938 -70.607713 C 76.592938 -70.607713 73.473052 -15.743604 73.473052 -15.743604 Z M 73.473052 -15.743604 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="10"
                />
                <path
                  stroke-linecap="butt"
                  transform="matrix(0.425697, 0, 0, 0.425697, 372.692268, 152.981834)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="miter"
                  d="M -15.885913 -15.914625 C -7.260346 -30.183514 16.680189 -20.823857 9.394338 3.116678 C 1.631328 23.129828 -7.388812 28.268463 -16.675061 30.186276 C -16.675061 30.186276 -15.885913 -15.914625 -15.885913 -15.914625 Z M -15.885913 -15.914625 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="10"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 317.602853, 158.628705)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M 3.346257 -33.639238 C 2.15336 -8.82697 -3.214679 12.204731 -12.711978 29.483392 C -3.554196 32.768449 4.869496 33.640181 12.715091 32.603278 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 337.499933, 114.200864)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 66.141736 75.185382 C 53.341028 67.275553 44.788871 49.657375 41.219354 20.660789 C 19.205807 29.671754 2.330896 25.202976 -10.038534 8.942865 C -25.729724 23.597153 -46.504493 29.268004 -70.812074 28.625674 C -91.072979 30.543486 -99.303972 20.679142 -96.532779 0.0420149 C -87.659457 -40.993659 -62.727899 -44.755874 -32.217251 -35.57974 C -19.673475 -75.183937 29.584015 -68.393597 32.557083 -35.57974 C 63.774293 -42.186557 80.952017 -35.469626 72.234689 -4.179007 C 92.477242 -2.196962 99.304287 8.722638 93.376504 28.157691 C 93.376504 28.157691 85.723607 70.496377 85.723607 70.496377 C 79.080086 68.94561 72.56503 70.854246 66.141736 75.185382 Z M 66.141736 75.185382 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 341.813943, 144.044765)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M -12.262705 -4.307827 C -1.416514 -5.950355 6.768598 -2.527657 12.265103 5.951092 "
                  stroke="#231f20"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 311.510719, 141.148307)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M -9.706001 3.294539 C -4.769241 -0.963187 1.213599 -3.303102 9.701524 -1.009068 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 339.693542, 153.644637)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 4.977624 -0.000248818 C 4.977624 5.459551 2.747823 9.891624 0.00415904 9.891624 C -2.748681 9.891624 -4.978482 5.459551 -4.978482 -0.000248818 C -4.978482 -5.460049 -2.748681 -9.892122 0.00415904 -9.892122 C 2.747823 -9.892122 4.977624 -5.460049 4.977624 -0.000248818 Z M 4.977624 -0.000248818 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 310.592934, 151.147507)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 3.938478 0.00218692 C 3.938478 4.43426 2.17666 8.040481 0.00191616 8.040481 C -2.172828 8.040481 -3.943822 4.43426 -3.943822 0.00218692 C -3.943822 -4.439062 -2.172828 -8.036107 0.00191616 -8.036107 C 2.17666 -8.036107 3.938478 -4.439062 3.938478 0.00218692 Z M 3.938478 0.00218692 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="butt"
                  transform="matrix(0.425697, 0, 0, 0.425697, 333.568619, 184.006185)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="miter"
                  d="M -20.339513 -1.528591 C -8.42889 19.402172 20.338292 3.233823 17.108292 -19.403701 C 5.463778 -9.686175 -6.969885 -3.519812 -20.339513 -1.528591 Z M -20.339513 -1.528591 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="10"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 210.188524, 349.303338)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 13.458985 0.00317015 C 13.458985 7.426663 7.430265 13.455384 -0.00240448 13.455384 C -7.425897 13.455384 -13.454618 7.426663 -13.454618 0.00317015 C -13.454618 -7.429499 -7.425897 -13.458219 -0.00240448 -13.458219 C 7.430265 -13.458219 13.458985 -7.429499 13.458985 0.00317015 Z M 13.458985 0.00317015 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 210.188524, 361.857582)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 19.102308 13.878527 C 19.102308 13.878527 -19.097941 13.878527 -19.097941 13.878527 C -19.097941 13.878527 -19.097941 5.225433 -19.097941 5.225433 C -19.097941 -5.327122 -10.545783 -13.87928 -0.00240448 -13.87928 C 10.55015 -13.87928 19.102308 -5.327122 19.102308 5.225433 C 19.102308 5.225433 19.102308 13.878527 19.102308 13.878527 Z M 19.102308 13.878527 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 240.511741, 349.303338)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 13.452162 0.00317015 C 13.452162 7.426663 7.432617 13.455384 -0.0000518386 13.455384 C -7.432721 13.455384 -13.452265 7.426663 -13.452265 0.00317015 C -13.452265 -7.429499 -7.432721 -13.458219 -0.0000518386 -13.458219 C 7.432617 -13.458219 13.452162 -7.429499 13.452162 0.00317015 Z M 13.452162 0.00317015 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 240.511741, 361.857582)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 19.104661 13.878527 C 19.104661 13.878527 -19.104764 13.878527 -19.104764 13.878527 C -19.104764 13.878527 -19.104764 5.225433 -19.104764 5.225433 C -19.104764 -5.327122 -10.552607 -13.87928 -0.0000518386 -13.87928 C 10.552503 -13.87928 19.104661 -5.327122 19.104661 5.225433 C 19.104661 5.225433 19.104661 13.878527 19.104661 13.878527 Z M 19.104661 13.878527 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.344814, 0, 0, 0.344814, 225.350579, 348.578541)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 17.539465 -0.00120519 C 17.539465 9.684715 9.688772 17.546737 0.00285205 17.546737 C -9.694397 17.546737 -17.54509 9.684715 -17.54509 -0.00120519 C -17.54509 -9.687125 -9.694397 -17.549147 0.00285205 -17.549147 C 9.688772 -17.549147 17.539465 -9.687125 17.539465 -0.00120519 Z M 17.539465 -0.00120519 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.344814, 0, 0, 0.344814, 225.350579, 361.838365)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 24.903031 18.096001 C 24.903031 18.096001 -24.908655 18.096001 -24.908655 18.096001 C -24.908655 18.096001 -24.908655 6.812753 -24.908655 6.812753 C -24.908655 -6.940121 -13.750022 -18.087425 0.00285205 -18.087425 C 13.755726 -18.087425 24.903031 -6.940121 24.903031 6.812753 C 24.903031 6.812753 24.903031 18.096001 24.903031 18.096001 Z M 24.903031 18.096001 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  fill="#ccf3e5"
                  d="M 72.492188 374.398438 C 53.617188 356.5 46.148438 330.222656 49.390625 302.414062 C 51.164062 287.234375 50.980469 271.90625 49.40625 256.703125 C 46.023438 223.996094 59.328125 186.039062 88.003906 155.800781 C 122.78125 119.128906 170.085938 104.425781 206.964844 115.273438 C 223.988281 120.28125 242.207031 119.753906 258.75 113.335938 C 295.617188 99.042969 335.015625 103.289062 361.195312 128.117188 C 400.34375 165.238281 395.113281 234.3125 349.511719 282.402344 C 324.230469 309.0625 291.847656 323.671875 261.339844 325.070312 C 249.335938 325.625 238.210938 331.457031 230.734375 340.867188 C 227.941406 344.382812 224.957031 347.824219 221.785156 351.171875 C 176.339844 399.089844 109.5 409.492188 72.492188 374.398438 Z M 72.492188 374.398438 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 37.597404, 36.075225)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M 440.427528 748.017781 C 440.427528 748.017781 440.427528 549.005773 440.427528 549.005773 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 144.166303, 294.618676)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -68.807922 68.808338 C -68.807922 68.808338 68.80657 -68.806153 68.80657 -68.806153 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 37.597404, 36.075225)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M 81.952651 413.520144 C 81.952651 413.520144 281.102302 413.520144 281.102302 413.520144 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 146.285854, 146.639295)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -55.407139 -55.402377 C -55.407139 -55.402377 55.403863 55.399449 55.403863 55.399449 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 37.597404, 36.075225)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M 440.427528 140.493434 C 440.427528 140.493434 440.427528 268.151819 440.427528 268.151819 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 225.085273, 69.723568)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 74.043792 -0.00214134 C 74.043792 40.895891 40.890417 74.040089 0.00156124 74.040089 C -40.896471 74.040089 -74.040669 40.895891 -74.040669 -0.00214134 C -74.040669 -40.890997 -40.896471 -74.044372 0.00156124 -74.044372 C 40.890417 -74.044372 74.043792 -40.890997 74.043792 -0.00214134 Z M 74.043792 -0.00214134 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 225.085273, 218.956671)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 181.789965 0.000845446 C 181.789965 100.396935 100.39765 181.789249 0.00156124 181.789249 C -100.394528 181.789249 -181.786842 100.396935 -181.786842 0.000845446 C -181.786842 -100.395244 -100.394528 -181.787558 0.00156124 -181.787558 C 100.39765 -181.787558 181.789965 -100.395244 181.789965 0.000845446 Z M 181.789965 0.000845446 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 71.245741, 212.109304)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 74.043058 0.000166314 C 74.043058 40.889022 40.889684 74.042397 0.000827631 74.042397 C -40.897205 74.042397 -74.041403 40.889022 -74.041403 0.000166314 C -74.041403 -40.88869 -40.897205 -74.042064 0.000827631 -74.042064 C 40.889684 -74.042064 74.043058 -40.88869 74.043058 0.000166314 Z M 74.043058 0.000166314 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 113.591491, 111.33073)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 57.23686 0.00305697 C 57.23686 31.614841 31.617092 57.243785 -0.0038684 57.243785 C -31.615652 57.243785 -57.23542 31.614841 -57.23542 0.00305697 C -57.23542 -31.608727 -31.615652 -57.237671 -0.0038684 -57.237671 C 31.617092 -57.237671 57.23686 -31.608727 57.23686 0.00305697 Z M 57.23686 0.00305697 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 114.874973, 323.91002)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 57.240791 0.000319434 C 57.240791 31.612103 31.611847 57.241047 0.0000633 57.241047 C -31.611721 57.241047 -57.240665 31.612103 -57.240665 0.000319434 C -57.240665 -31.611464 -31.611721 -57.240409 0.0000633 -57.240409 C 31.611847 -57.240409 57.240791 -31.611464 57.240791 0.000319434 Z M 57.240791 0.000319434 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 225.085273, 354.504831)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 74.043792 -0.00217248 C 74.043792 40.89586 40.890417 74.040058 0.00156124 74.040058 C -40.896471 74.040058 -74.040669 40.89586 -74.040669 -0.00217248 C -74.040669 -40.891029 -40.896471 -74.044403 0.00156124 -74.044403 C 40.890417 -74.044403 74.043792 -40.891029 74.043792 -0.00217248 Z M 74.043792 -0.00217248 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 224.097654, 70.577094)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 51.560706 38.266905 C 51.560706 38.266905 -51.560695 38.266905 -51.560695 38.266905 C -51.560695 38.266905 -51.560695 -38.271235 -51.560695 -38.271235 C -51.560695 -38.271235 51.560706 -38.271235 51.560706 -38.271235 C 51.560706 -38.271235 51.560706 38.266905 51.560706 38.266905 Z M 51.560706 38.266905 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 226.072044, 68.948586)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 51.556634 38.265967 C 51.556634 38.265967 -51.555591 38.265967 -51.555591 38.265967 C -51.555591 38.265967 -51.555591 -38.262996 -51.555591 -38.262996 C -51.555591 -38.262996 51.556634 -38.262996 51.556634 -38.262996 C 51.556634 -38.262996 51.556634 38.265967 51.556634 38.265967 Z M 51.556634 38.265967 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 226.072451, 60.802871)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -51.556548 -19.13715 C -51.556548 -19.13715 0.00415298 19.136507 0.00415298 19.136507 C 0.00415298 19.136507 51.555677 -19.13715 51.555677 -19.13715 C 51.555677 -19.13715 -51.556548 -19.13715 -51.556548 -19.13715 Z M -51.556548 -19.13715 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 56.793764, 212.108894)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 12.881425 41.284559 C 12.881425 41.284559 -12.885161 41.284559 -12.885161 41.284559 C -12.885161 41.284559 -12.885161 -41.291477 -12.885161 -41.291477 C -12.885161 -41.291477 12.881425 -41.291477 12.881425 -41.291477 C 12.881425 -41.291477 12.881425 41.284559 12.881425 41.284559 Z M 12.881425 41.284559 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 71.245308, 215.90525)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 12.885139 32.366576 C 12.885139 32.366576 -12.881447 32.366576 -12.881447 32.366576 C -12.881447 32.366576 -12.881447 -32.371054 -12.881447 -32.371054 C -12.881447 -32.371054 12.885139 -32.371054 12.885139 -32.371054 C 12.885139 -32.371054 12.885139 32.366576 12.885139 32.366576 Z M 12.885139 32.366576 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 85.696861, 220.896983)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 12.879656 20.640543 C 12.879656 20.640543 -12.877754 20.640543 -12.877754 20.640543 C -12.877754 20.640543 -12.877754 -20.642887 -12.877754 -20.642887 C -12.877754 -20.642887 12.879656 -20.642887 12.879656 -20.642887 C 12.879656 -20.642887 12.879656 20.640543 12.879656 20.640543 Z M 12.879656 20.640543 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 113.591491, 110.784998)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 46.115384 10.965852 C 46.115384 10.965852 46.115384 -10.965109 46.115384 -10.965109 C 46.115384 -10.965109 34.470869 -10.965109 34.470869 -10.965109 C 33.846892 -12.928802 33.066921 -14.819086 32.130955 -16.617608 C 32.130955 -16.617608 40.361948 -24.857777 40.361948 -24.857777 C 40.361948 -24.857777 24.85428 -40.365445 24.85428 -40.365445 C 24.85428 -40.365445 16.623288 -32.125276 16.623288 -32.125276 C 14.815589 -33.061242 12.934481 -33.850389 10.961613 -34.474366 C 10.961613 -34.474366 10.961613 -46.118881 10.961613 -46.118881 C 10.961613 -46.118881 -10.960173 -46.118881 -10.960173 -46.118881 C -10.960173 -46.118881 -10.960173 -34.474366 -10.960173 -34.474366 C -12.933042 -33.850389 -14.823326 -33.061242 -16.621848 -32.125276 C -16.621848 -32.125276 -24.862017 -40.365445 -24.862017 -40.365445 C -24.862017 -40.365445 -40.360509 -24.857777 -40.360509 -24.857777 C -40.360509 -24.857777 -32.129516 -16.617608 -32.129516 -16.617608 C -33.065482 -14.819086 -33.854629 -12.928802 -34.478606 -10.965109 C -34.478606 -10.965109 -46.113945 -10.965109 -46.113945 -10.965109 C -46.113945 -10.965109 -46.113945 10.965852 -46.113945 10.965852 C -46.113945 10.965852 -34.478606 10.965852 -34.478606 10.965852 C -33.854629 12.929545 -33.065482 14.819829 -32.129516 16.618351 C -32.129516 16.618351 -40.360509 24.85852 -40.360509 24.85852 C -40.360509 24.85852 -24.862017 40.366188 -24.862017 40.366188 C -24.862017 40.366188 -16.621848 32.126019 -16.621848 32.126019 C -14.823326 33.061985 -12.933042 33.851132 -10.960173 34.475109 C -10.960173 34.475109 -10.960173 46.119624 -10.960173 46.119624 C -10.960173 46.119624 10.961613 46.119624 10.961613 46.119624 C 10.961613 46.119624 10.961613 34.475109 10.961613 34.475109 C 12.934481 33.851132 14.815589 33.061985 16.623288 32.126019 C 16.623288 32.126019 24.85428 40.366188 24.85428 40.366188 C 24.85428 40.366188 40.361948 24.85852 40.361948 24.85852 C 40.361948 24.85852 32.130955 16.618351 32.130955 16.618351 C 33.066921 14.819829 33.846892 12.929545 34.470869 10.965852 C 34.470869 10.965852 46.115384 10.965852 46.115384 10.965852 Z M 16.375532 0.862928 C 16.173657 4.744433 14.62289 8.258893 12.191215 10.965852 C 11.796641 11.397131 11.392891 11.800881 10.961613 12.195454 C 8.254653 14.62713 4.740193 16.168721 0.858688 16.370596 C 0.574228 16.388948 0.289768 16.388948 -0.0038684 16.388948 C -0.288329 16.388948 -0.572789 16.388948 -0.866425 16.370596 C -4.738754 16.168721 -8.253213 14.62713 -10.960173 12.195454 C -11.391452 11.800881 -11.804378 11.397131 -12.189775 10.965852 C -14.621451 8.258893 -16.172218 4.744433 -16.374093 0.862928 C -16.383269 0.578468 -16.392445 0.294008 -16.392445 0.000371464 C -16.392445 -0.293265 -16.383269 -0.577725 -16.374093 -0.862185 C -16.172218 -4.74369 -14.621451 -8.25815 -12.189775 -10.965109 C -11.804378 -11.396388 -11.391452 -11.800138 -10.960173 -12.194711 C -8.253213 -14.626387 -4.738754 -16.167978 -0.866425 -16.369853 C -0.572789 -16.388205 -0.288329 -16.397381 -0.0038684 -16.397381 C 0.289768 -16.397381 0.574228 -16.388205 0.858688 -16.369853 C 4.740193 -16.167978 8.254653 -14.626387 10.961613 -12.194711 C 11.392891 -11.800138 11.796641 -11.396388 12.191215 -10.965109 C 14.62289 -8.25815 16.173657 -4.74369 16.375532 -0.862185 C 16.384708 -0.577725 16.393884 -0.293265 16.393884 0.000371464 C 16.393884 0.294008 16.384708 0.578468 16.375532 0.862928 Z M 16.375532 0.862928 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 222.266312, 222.787497)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -25.942546 56.748894 C -25.942546 56.748894 -25.942546 49.655741 -25.942546 49.655741 C -25.942546 27.009041 -24.171552 12.7218 -20.629564 6.812369 C -17.0784 0.902938 -7.718743 -7.649219 7.46776 -18.85328 C 15.423469 -24.698478 20.965854 -30.149102 24.076564 -35.1868 C 27.187273 -40.224497 28.747216 -46.473445 28.747216 -53.942819 C 28.747216 -63.146482 25.820029 -70.395628 19.974831 -75.690258 C 14.120457 -80.975711 7.027305 -83.618438 -1.304625 -83.618438 C -23.336524 -83.618438 -35.71513 -68.06489 -38.449618 -36.957794 C -38.449618 -36.957794 -89.597393 -44.234468 -89.597393 -44.234468 C -85.743416 -72.359321 -75.438617 -93.638777 -58.701347 -108.072837 C -41.973254 -122.506897 -21.528826 -129.728515 2.613585 -129.728515 C 27.251506 -129.728515 47.906985 -122.635363 64.580022 -108.449059 C 81.262235 -94.262754 89.594165 -76.277531 89.594165 -54.502563 C 89.594165 -27.497199 75.719849 -4.914731 47.971218 13.254015 C 35.895425 21.2189 28.591222 27.440319 26.040256 31.918273 C 23.489291 36.396227 22.213808 44.6731 22.213808 56.748894 C 22.213808 56.748894 -25.942546 56.748894 -25.942546 56.748894 Z M 31.545937 129.726692 C 31.545937 129.726692 -27.062035 129.726692 -27.062035 129.726692 C -27.062035 129.726692 -27.062035 73.357697 -27.062035 73.357697 C -27.062035 73.357697 31.545937 73.357697 31.545937 73.357697 C 31.545937 73.357697 31.545937 129.726692 31.545937 129.726692 Z M 31.545937 129.726692 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 114.874959, 324.673721)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 36.732164 -0.0135121 C 36.732164 20.284098 20.279355 36.718555 0.000097072 36.718555 C -20.279161 36.718555 -36.73197 20.284098 -36.73197 -0.0135121 C -36.73197 -19.999133 -20.747143 -36.250068 -0.880812 -36.718051 C -0.880812 -36.718051 -0.880812 -0.0135121 -0.880812 -0.0135121 C -0.880812 -0.0135121 36.732164 -0.0135121 36.732164 -0.0135121 Z M 36.732164 -0.0135121 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 125.318602, 313.973385)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -18.807058 -18.363158 C -18.807058 -18.363158 -18.807058 18.359733 -18.807058 18.359733 C -18.807058 18.359733 18.805918 18.359733 18.805918 18.359733 C 18.411344 -2.543502 3.279898 -17.867647 -18.807058 -18.363158 Z M -18.807058 -18.363158 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 225.085273, 405.211712)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 431.1606 13.789911 C 431.1606 13.789911 -431.157478 13.789911 -431.157478 13.789911 C -431.157478 13.789911 -431.157478 -13.784374 -431.157478 -13.784374 C -431.157478 -13.784374 431.1606 -13.784374 431.1606 -13.784374 C 431.1606 -13.784374 431.1606 13.789911 431.1606 13.789911 Z M 431.1606 13.789911 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 287.96236, 318.249518)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 54.796534 -39.263547 C 54.796534 -39.263547 41.729719 131.348325 41.729719 131.348325 C 36.903072 181.248145 -44.149726 173.40255 -39.323079 123.50273 C -54.803218 81.558618 -38.855096 -66.645133 -23.274019 -181.245878 C 20.037336 -158.296366 46.620598 -111.764187 54.796534 -39.263547 Z M 54.796534 -39.263547 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 346.105724, 306.464969)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -159.692871 -153.599613 C -129.8062 -171.970234 -100.552683 -187.964237 -72.565472 -199.250882 C -72.565472 -199.250882 58.864304 -209.959432 58.864304 -209.959432 C 93.733616 -196.709093 127.602729 -180.604977 159.691672 -159.39893 C 159.691672 -159.39893 92.485662 197.451771 92.485662 197.451771 C 4.293831 209.188047 -66.316525 209.958842 -110.921715 194.478703 C -110.921715 194.478703 -159.692871 -153.599613 -159.692871 -153.599613 Z M -159.692871 -153.599613 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="butt"
                  transform="matrix(0.425697, 0, 0, 0.425697, 345.201978, 212.32515)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="miter"
                  d="M 44.268367 -67.538539 C 44.268367 -67.538539 40.038169 -6.508067 40.038169 -6.508067 C 40.038169 -6.508067 -20.625257 67.54334 -20.625257 67.54334 C -20.625257 67.54334 -44.272156 23.378603 -44.272156 23.378603 C -44.272156 23.378603 -44.272156 -35.504653 -44.272156 -35.504653 C -44.272156 -35.504653 44.268367 -67.538539 44.268367 -67.538539 Z M 44.268367 -67.538539 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="10"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 345.20154, 198.691782)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -42.435899 3.522752 C -42.435899 3.522752 -42.435899 24.389282 -42.435899 24.389282 C 2.875854 25.261015 25.467497 5.936076 42.43417 -25.253606 C 13.722045 -4.919292 -12.512524 3.999911 -42.435899 3.522752 Z M -42.435899 3.522752 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 357.467152, 224.429408)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -49.437259 39.109342 C -49.437259 39.109342 -18.064055 21.711391 -18.064055 21.711391 C -18.064055 21.711391 -0.519285 46.688829 -0.519285 46.688829 C -0.519285 46.688829 49.435592 -20.223545 49.435592 -20.223545 C 49.435592 -20.223545 24.760966 -46.687517 24.760966 -46.687517 C 24.760966 -46.687517 12.042843 -46.687517 12.042843 -46.687517 C 12.042843 -46.687517 11.226167 -34.942065 11.226167 -34.942065 C 11.226167 -34.942065 -49.437259 39.109342 -49.437259 39.109342 Z M -49.437259 39.109342 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 325.819131, 229.366647)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 24.906805 27.511321 C 24.906805 27.511321 3.095133 13.682887 3.095133 13.682887 C 3.095133 13.682887 -21.038102 38.063876 -21.038102 38.063876 C -21.038102 38.063876 -24.91043 -18.139948 -24.91043 -18.139948 C -24.91043 -18.139948 1.259906 -38.061337 1.259906 -38.061337 C 1.259906 -38.061337 1.259906 -16.653415 1.259906 -16.653415 C 1.259906 -16.653415 24.906805 27.511321 24.906805 27.511321 Z M 24.906805 27.511321 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  fill="#231f1f"
                  d="M 298.886719 389.253906 C 298.886719 389.253906 298.886719 404.382812 298.886719 404.382812 C 325.472656 412.476562 354.949219 411.480469 386.363281 404.382812 C 386.363281 404.382812 385.476562 390.519531 385.476562 390.519531 C 351.859375 395.648438 322.488281 395.816406 298.886719 389.253906 Z M 298.886719 389.253906 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 342.624382, 400.865314)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M -102.743728 -27.276248 C -102.743728 -27.276248 -102.743728 8.262922 -102.743728 8.262922 C -40.290955 27.275873 28.952157 24.926782 102.746632 8.262922 C 102.746632 8.262922 100.663649 -24.30318 100.663649 -24.30318 C 21.693835 -12.254915 -47.301522 -11.860342 -102.743728 -27.276248 Z M -102.743728 -27.276248 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 338.457644, 254.305635)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -26.593877 -44.901052 C -26.593877 -44.901052 -2.093597 48.475294 -2.093597 48.475294 C -2.093597 48.475294 26.591 -48.470568 26.591 -48.470568 C 26.591 -48.470568 -4.782205 -31.072617 -4.782205 -31.072617 C -4.782205 -31.072617 -26.593877 -44.901052 -26.593877 -44.901052 Z M -26.593877 -44.901052 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 329.164257, 264.640706)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -15.086023 -50.817623 C -15.086023 -50.817623 15.085108 50.817244 15.085108 50.817244 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 348.290412, 261.978812)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 11.778986 -38.545049 C 11.778986 -38.545049 -11.776152 38.543658 -11.776152 38.543658 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 329.720668, 382.8511)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M -65.191767 -5.596355 C -24.587371 5.515944 19.210319 5.598529 65.19193 -1.889197 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 400.248805, 315.591048)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -48.62153 -40.478758 C -48.62153 -40.478758 -39.904202 130.417574 -39.904202 130.417574 C -36.343862 180.418331 35.982432 156.964131 44.947515 120.140303 C 48.617969 7.815239 41.561522 -88.240539 33.036893 -180.423988 C -10.843383 -158.584787 -38.601191 -112.740819 -48.62153 -40.478758 Z M -48.62153 -40.478758 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 325.480717, 357.601369)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -133.770275 -20.517382 C -66.454151 -49.045984 1.733705 -70.674134 54.680002 -78.024218 C 74.638095 -80.786234 94.97241 -78.73078 114.040417 -72.206548 C 114.040417 -72.206548 130.72263 -66.489816 130.72263 -66.489816 C 130.72263 -66.489816 136.879817 -25.389909 136.879817 -25.389909 C 136.879817 -25.389909 88.760166 -27.830761 88.760166 -27.830761 C 88.760166 -27.830761 -72.877445 70.840215 -72.877445 70.840215 C -112.041188 80.787145 -136.880985 63.150614 -133.770275 -20.517382 Z M -133.770275 -20.517382 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 356.055521, 353.684096)"
                  fill-opacity="1"
                  fill="#ffffff"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 149.75256 -18.445211 C 100.118848 -39.486087 68.084962 -61.316112 25.69122 -71.657615 C -16.656642 -81.980767 -73.567029 -87.10105 -114.923868 -73.327672 C -114.923868 -73.327672 -154.684059 -61.967617 -154.684059 -61.967617 C -154.684059 -61.967617 -150.463037 -31.833191 -150.463037 -31.833191 C -150.463037 -31.833191 -99.168445 -25.308959 -99.168445 -25.308959 C -79.531516 -22.803875 -60.656207 -16.178705 -43.762943 -5.873906 C -43.762943 -5.873906 92.254901 77.160936 92.254901 77.160936 C 131.418643 87.09869 154.689321 70.866108 149.75256 -18.445211 Z M 149.75256 -18.445211 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  fill="#ffffff"
                  d="M 394.125 325.464844 C 394.125 325.464844 395.507812 351.289062 395.507812 351.289062 C 395.507812 351.289062 419.601562 357.242188 419.601562 357.242188 C 419.59375 347.988281 419.273438 338.382812 418.675781 328.464844 C 418.675781 328.464844 394.125 325.464844 394.125 325.464844 Z M 394.125 325.464844 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  fill="#ffffff"
                  d="M 269.113281 341.433594 C 269.113281 341.433594 268.960938 350.289062 268.960938 350.289062 C 268.960938 350.289062 281.792969 346.175781 281.792969 346.175781 C 281.792969 346.175781 280.851562 336.609375 280.851562 336.609375 C 280.851562 336.609375 269.113281 341.433594 269.113281 341.433594 Z M 269.113281 341.433594 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  fill="#231f1f"
                  d="M 298.507812 398.566406 C 298.507812 398.566406 298.300781 410.867188 298.300781 410.867188 C 298.300781 410.867188 327.230469 409.40625 326.652344 408.921875 C 326.078125 408.4375 326.464844 399.429688 326.464844 399.429688 C 326.464844 399.429688 298.507812 398.566406 298.507812 398.566406 Z M 298.507812 398.566406 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  fill="#231f1f"
                  d="M 364.261719 181.820312 C 364.261719 181.820312 325.84375 190.84375 325.84375 190.84375 C 325.84375 190.84375 325.519531 195.679688 325.519531 195.679688 C 325.519531 195.679688 326.050781 203.003906 326.050781 203.003906 C 326.050781 203.003906 353.660156 199.84375 359.871094 191.5 C 366.085938 183.15625 363.578125 187.4375 363.578125 187.4375 C 363.578125 187.4375 364.261719 181.820312 364.261719 181.820312 Z M 364.261719 181.820312 "
                  fill-opacity="1"
                  fill-rule="nonzero"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 302.144884, 137.270141)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M -6.00202 -35.384608 C -10.204689 -7.287284 -4.680656 14.533564 2.348263 35.390918 C 2.348263 35.390918 10.203034 -34.494523 10.203034 -34.494523 C 10.203034 -34.494523 -6.00202 -35.384608 -6.00202 -35.384608 Z M -6.00202 -35.384608 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="butt"
                  transform="matrix(0.425697, 0, 0, 0.425697, 334.386723, 152.643315)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="miter"
                  d="M 73.473299 -15.74339 C 73.473299 -15.74339 72.803441 28.641573 72.803441 28.641573 C 72.803441 28.641573 69.013698 81.94574 69.013698 81.94574 C 33.768165 106.712127 -3.505294 119.228375 -44.476736 109.584257 C -53.24912 107.519627 -60.287216 100.986219 -63.049232 92.406533 C -75.216787 54.600858 -76.593207 2.205129 -67.481305 -64.358551 C -36.034692 -119.231837 33.547937 -115.882547 76.593185 -70.607499 C 76.593185 -70.607499 73.473299 -15.74339 73.473299 -15.74339 Z M 73.473299 -15.74339 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="10"
                />
                <path
                  stroke-linecap="butt"
                  transform="matrix(0.425697, 0, 0, 0.425697, 372.426538, 152.716118)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="miter"
                  d="M -15.885666 -15.914411 C -7.260099 -30.192477 16.680436 -20.823643 9.394585 3.116892 C 1.631575 23.130042 -7.388565 28.268677 -16.674813 30.186489 C -16.674813 30.186489 -15.885666 -15.914411 -15.885666 -15.914411 Z M -15.885666 -15.914411 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="10"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 317.337123, 158.362989)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M 3.346505 -33.639024 C 2.144431 -8.826756 -3.214432 12.204944 -12.711731 29.47443 C -3.553949 32.768662 4.869743 33.640395 12.715338 32.603492 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 337.234203, 113.935148)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 66.141983 75.185595 C 53.341275 67.275767 44.789118 49.657589 41.219602 20.661003 C 19.206055 29.671967 2.331143 25.20319 -10.038287 8.943079 C -25.729477 23.597366 -46.504246 29.268217 -70.811826 28.625888 C -91.072732 30.5437 -99.303725 20.679355 -96.532532 0.0422285 C -87.65921 -40.993446 -62.727652 -44.755661 -32.217004 -35.579526 C -19.673228 -75.183723 29.584263 -68.393384 32.55733 -35.579526 C 63.774541 -42.186343 80.952265 -35.469413 72.234937 -4.178793 C 92.47749 -2.196748 99.304534 8.722852 93.376751 28.157905 C 93.376751 28.157905 85.723855 70.49659 85.723855 70.49659 C 79.080333 68.945824 72.565278 70.85446 66.141983 75.185595 Z M 66.141983 75.185595 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 341.548213, 143.779049)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M -12.262458 -4.307613 C -1.416267 -5.950141 6.768845 -2.527443 12.26535 5.951305 "
                  stroke="#231f20"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 311.244988, 140.882591)"
                  fill="none"
                  stroke-linejoin="round"
                  d="M -9.705754 3.294753 C -4.768993 -0.962974 1.213846 -3.302888 9.701771 -1.008855 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 339.427814, 153.378921)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 4.977866 -0.0000352359 C 4.977866 5.459765 2.748065 9.891838 0.00440077 9.891838 C -2.74844 9.891838 -4.97824 5.459765 -4.97824 -0.0000352359 C -4.97824 -5.459835 -2.74844 -9.891908 0.00440077 -9.891908 C 2.748065 -9.891908 4.977866 -5.459835 4.977866 -0.0000352359 Z M 4.977866 -0.0000352359 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 310.327204, 150.881791)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 3.938725 0.0024005 C 3.938725 4.434474 2.176907 8.031518 0.00216351 8.031518 C -2.17258 8.031518 -3.943574 4.434474 -3.943574 0.0024005 C -3.943574 -4.438849 -2.17258 -8.035893 0.00216351 -8.035893 C 2.176907 -8.035893 3.938725 -4.438849 3.938725 0.0024005 Z M 3.938725 0.0024005 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="butt"
                  transform="matrix(0.425697, 0, 0, 0.425697, 333.302889, 183.740469)"
                  fill-opacity="1"
                  fill="#231f1f"
                  fill-rule="nonzero"
                  stroke-linejoin="miter"
                  d="M -20.339266 -1.537554 C -8.428643 19.402386 20.338539 3.234036 17.10854 -19.403488 C 5.464025 -9.685961 -6.969638 -3.519599 -20.339266 -1.537554 Z M -20.339266 -1.537554 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="10"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 209.92281, 349.037608)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 13.459193 0.0034175 C 13.459193 7.42691 7.430473 13.455631 -0.00219653 13.455631 C -7.425689 13.455631 -13.45441 7.42691 -13.45441 0.0034175 C -13.45441 -7.429252 -7.425689 -13.457972 -0.00219653 -13.457972 C 7.430473 -13.457972 13.459193 -7.429252 13.459193 0.0034175 Z M 13.459193 0.0034175 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 209.92281, 361.591852)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 19.102516 13.878775 C 19.102516 13.878775 -19.097733 13.878775 -19.097733 13.878775 C -19.097733 13.878775 -19.097733 5.22568 -19.097733 5.22568 C -19.097733 -5.326875 -10.545575 -13.879032 -0.00219653 -13.879032 C 10.550358 -13.879032 19.102516 -5.326875 19.102516 5.22568 C 19.102516 5.22568 19.102516 13.878775 19.102516 13.878775 Z M 19.102516 13.878775 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 240.246025, 349.037608)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 13.452375 0.0034175 C 13.452375 7.42691 7.432831 13.455631 0.000161744 13.455631 C -7.432507 13.455631 -13.452052 7.42691 -13.452052 0.0034175 C -13.452052 -7.429252 -7.432507 -13.457972 0.000161744 -13.457972 C 7.432831 -13.457972 13.452375 -7.429252 13.452375 0.0034175 Z M 13.452375 0.0034175 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.425697, 0, 0, 0.425697, 240.246025, 361.591852)"
                  fill-opacity="1"
                  fill="#02c37e"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 19.104874 13.878775 C 19.104874 13.878775 -19.104551 13.878775 -19.104551 13.878775 C -19.104551 13.878775 -19.104551 5.22568 -19.104551 5.22568 C -19.104551 -5.326875 -10.552393 -13.879032 0.000161744 -13.879032 C 10.54354 -13.879032 19.104874 -5.326875 19.104874 5.22568 C 19.104874 5.22568 19.104874 13.878775 19.104874 13.878775 Z M 19.104874 13.878775 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.344814, 0, 0, 0.344814, 225.084863, 348.31281)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 17.539729 -0.000899812 C 17.539729 9.68502 9.689036 17.547042 0.00311573 17.547042 C -9.694133 17.547042 -17.544826 9.68502 -17.544826 -0.000899812 C -17.544826 -9.68682 -9.694133 -17.548842 0.00311573 -17.548842 C 9.689036 -17.548842 17.539729 -9.68682 17.539729 -0.000899812 Z M 17.539729 -0.000899812 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
                <path
                  stroke-linecap="round"
                  transform="matrix(0.344814, 0, 0, 0.344814, 225.084863, 361.572635)"
                  fill-opacity="1"
                  fill="#777777"
                  fill-rule="nonzero"
                  stroke-linejoin="round"
                  d="M 24.903294 18.096306 C 24.903294 18.096306 -24.908391 18.096306 -24.908391 18.096306 C -24.908391 18.096306 -24.908391 6.813059 -24.908391 6.813059 C -24.908391 -6.939815 -13.749758 -18.08712 0.00311573 -18.08712 C 13.75599 -18.08712 24.903294 -6.939815 24.903294 6.813059 C 24.903294 6.813059 24.903294 18.096306 24.903294 18.096306 Z M 24.903294 18.096306 "
                  stroke="#231f1f"
                  stroke-width="2"
                  stroke-opacity="1"
                  stroke-miterlimit="4"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
